export default "__VITE_ASSET__7bbb462a__"